import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header/Header';
import s from './Analytics.module.scss';

const Analytics = () => {
  const navigate = useNavigate();

  const items = [
    { title: 'Статус обновления API', link: '/analytics/update' },
    { title: 'Статистика цен', link: '/analytics/prices' },
  ];

  return (
    <>
      <Header
        title="Аналитика"
        breadCrumbs={[
          { name: 'Главная', link: '/' },
          { name: 'Аналитика', link: '/analytics' },
        ]}
      />
      <div className={s.menu}>
        {items.map((item, i) => (
          <div key={i} className={s.item}>
            <h3>{item.title}</h3>
            <button className="btn grey" onClick={() => navigate(item.link)}>
              Перейти
            </button>
          </div>
        ))}
      </div>
    </>
  );
};

export default Analytics;
